import Layout from "../Layout/Layout";
import "./Home.css";
import Commodore from "../../components/Card/Cards/Commodore";
import Serenity from "../../components/Card/Cards/Serenity";
import { JsonLDData } from "react-safe-json-ld";
import { Link } from "react-router-dom";

const Home = () => {
  const structuredData: JsonLDData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AutoRental",
        "@id": "https://earthboundmartian.com/#business",
        name: "Earthbound Martian Landship Rentals",
        description:
          "Rent rugged camper vans for kayaking, fishing, hiking, and camping adventures within 350 miles of DFW.",
        url: "https://earthboundmartian.com",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Richardson",
          addressRegion: "TX",
          addressCountry: "US",
        },
        areaServed: {
          "@type": "GeoCircle",
          center: {
            "@type": "GeoCoordinates",
            latitude: 32.9686,
            longitude: -96.9942,
          },
          radius: "350 mi",
        },
      },
    ],
  };

  return (
    <Layout structuredData={structuredData}>
      {/* Hero */}
      <section className="bg-alt-blk text-white homeHero">
        <div className="mx-auto px-6 text-center py-32 bg-gray-600/50 p-5">
          <h2 className="text-6xl md:text-7xl text-ray font-bold tracking-normal mb-6">
            Your office. Your life. Untethered.
          </h2>
          <p className="text-xl text-alt-wht max-w-2xl mx-auto">
            Landships for rent or ownership.
            <br className="hidden md:block" />
            Unique mobile offices, workspaces & cabins that move with you.
          </p>
          <Link
            to="/fleet"
            className="mt-12 inline-block bg-mars hover:bg-sunset px-12 py-5 rounded-2xl text-lg font-semibold transition-all"
          >
            Rent a Landship
          </Link>
        </div>
      </section>

      {/* Featured Fleet */}
      <section className="max-w-7xl mx-auto px-6 py-20">
        <h2 className="text-4xl font-bold text-alt-blk mb-12">Our Fleet</h2>

        <div className="space-y-16">
          <Commodore />
          <Serenity />
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="bg-zinc-100 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-alt-blk mb-12">
            Why Earthbound Martian?
          </h2>

          <div className="grid md:grid-cols-3 gap-10">
            <div className="text-center">
              <div className="text-5xl mb-4">🛠️</div>
              <h3 className="font-bold text-xl mb-3">
                Built Like We Live In It
              </h3>
              <p className="text-zinc-600">
                No floppy walls, no cheap countertops. We build them solid
                because we actually use them.
              </p>
            </div>

            <div className="text-center">
              <div className="text-5xl mb-4">🔒</div>
              <h3 className="font-bold text-xl mb-3">
                Safety Without Sacrifice
              </h3>
              <p className="text-zinc-600">
                Proper framing, real insulation, and sturdy fixtures. So you can
                work and sleep without worrying about the rig.
              </p>
            </div>

            <div className="text-center">
              <div className="text-5xl mb-4">🛣️</div>
              <h3 className="font-bold text-xl mb-3">Rugged But Civilized</h3>
              <p className="text-zinc-600">
                Tough enough for real roads, comfortable enough for long hauls.
                Adventure-ready without feeling like a rattletrap.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-alt-blk mb-4">
            But don't take our word for it
          </h2>

          <div className="grid md:grid-cols-3 gap-8 max-w-8xl mx-auto">
            {/* Add real testimonials here later */}
            <div className="bg-white p-8 rounded-3xl shadow">
              <p className="italic text-zinc-600 mb-6">
                “Great van, it had everything I needed to make a weekend camping
                trip more comfortable. Everything was as advertised, the pickup
                and drop-off processes went smooth. The solar panels were a
                great way to charge the battery without running the engine.
                Would definitely book again!”
              </p>
              <p className="font-semibold">— Sam</p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow">
              <p className="italic text-zinc-600 mb-6">
                “The hosts were very generous with their time to make sure we
                were informed on all the bells and whistles! Van drives
                FANtastic!”
              </p>
              <p className="font-semibold">— Mary A.</p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow">
              <p className="italic text-zinc-600 mb-6">
                “We found the Commodore to be very accommodating and to fulfill
                our camping needs for the weekend. Everything was just as
                described. I found Chris and Cally to be fantastic hosts and
                lovely people. They walked my daughter and me through the van
                set up at a perfect pace, made sure I knew where the instruction
                manual was in case issues came up, and shared their business
                card with me.”
              </p>
              <p className="font-semibold">— Patty M.</p>
            </div>
          </div>

          {/* Final CTA */}
          <div className="text-center mt-16">
            <Link
              to="/fleet/commodore"
              className="inline-block bg-mars hover:bg-sunset text-white px-14 py-6 rounded-2xl text-xl font-semibold transition-all"
            >
              Start Your Adventure!
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
